import { render, staticRenderFns } from "./doctorAudit.vue?vue&type=template&id=40826664&scoped=true&"
import script from "./doctorAudit.vue?vue&type=script&lang=js&"
export * from "./doctorAudit.vue?vue&type=script&lang=js&"
import style0 from "./doctorAudit.vue?vue&type=style&index=0&id=40826664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40826664",
  null
  
)

export default component.exports